import '../../css/vehicle/_view.scss';
import '../../css/common/_block-services.scss';
import '../../css/form/choices.scss';
import '../../css/common/_item-card-agency.scss';
import '../../css/common/_smartphoto.scss';
import '../../css/common/_item-card-testimonial.scss';
import '../../css/vehicle/_item.scss';
import '../../css/common/_block-avis-clients.scss';

import btnsAnchor from "../components/_btns-anchor";

import Choices from 'choices.js';
import smartPhoto from "smartphoto";

import btnMoreInItem from "../components/_btns-item-testimonial";
import btnMoreInItemResponses from "../components/_btns-item-testimonial-responses";
import favoriteVehicleView from '../components/_favorite-view';
import comparatorVehicleView from '../components/_comparator-view';
import arrayFromJsonCookie from '../components/arrayFromCookie'

import Swiper from 'swiper/bundle';

import 'swiper/swiper-bundle.css';
import '../../css/common/_block-swiper.scss';

window.addEventListener('DOMContentLoaded', () => {

    //Btn de PARTAGE
    const shareButton = document.getElementById('shareButton');
    if (shareButton) {
        import('../components/_share-button.js').then(({shareButton}) => {
            shareButton();
        });
    }

    // Slider d'images du véhicule
    let idSwiperViewVehicle = document.querySelector('#swiperViewVehicle');
    if ( idSwiperViewVehicle ) {
        try {
            if(idSwiperViewVehicle.querySelector('.swiper-slide') !== null) {
                const swiperViewVehicle = new Swiper('#swiperViewVehicle .swiper-container', {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    loop: true,
                    navigation: {
                        nextEl: '#swiper-button-next-ViewVehicle',
                        prevEl: '#swiper-button-prev-ViewVehicle',
                    },
                    pagination: {
                        el: '.swiper-pagination-ViewVehicle',
                    },
                    on: {
                        init: function () {

                            document.querySelector('#swiperViewVehicle .current-slide').innerHTML = '1/';
                            // Affichage images au chargement de la page
                            let prevSlideLoadedSrc   = document.querySelector('#swiperViewVehicle .swiper-slide-prev img').dataset.src;
                            document.getElementById('leftImg').setAttribute('src', prevSlideLoadedSrc);
                            let nextSlideLoadedSrc   = document.querySelector('#swiperViewVehicle .swiper-slide-next img').dataset.src;
                            document.getElementById('rightImg').setAttribute('src', nextSlideLoadedSrc);
                        },
                        paginationRender: function(){
                            const totalSlides = document.getElementsByClassName('swiper-pagination-bullet').length;
                            document.querySelector('.total-slides').innerHTML = totalSlides + ' photos';
                        }
                    },
                });
                swiperViewVehicle.on('slideChangeTransitionEnd', function() {

                    // Affichage du N° de la photo courante
                    let activeSlideIndex = swiperViewVehicle.realIndex + 1;
                    if (activeSlideIndex) {
                        document.querySelector('#swiperViewVehicle .current-slide').innerHTML = activeSlideIndex +'/';
                    }

                    // Affichage IMG "next"
                    //let nextSlideIndex = swiperViewVehicle.realIndex + 1;
                    let nextSlideSrc   = document.querySelector('#swiperViewVehicle .swiper-slide-next img').dataset.src;
                    if (nextSlideSrc) {
                        document.getElementById('rightImg').setAttribute('src', nextSlideSrc);
                    }

                    // Affichage IMG "prev"
                    //let prevSlideIndex = swiperViewVehicle.realIndex - 1;
                    let prevSlideSrc   = document.querySelector('#swiperViewVehicle .swiper-slide-prev img').dataset.src;
                    if (prevSlideSrc) {
                        document.getElementById('leftImg').setAttribute('src', prevSlideSrc);
                    }
                });
            }
        } catch (error) {
            console.log('Il manque le block avec l\'id "#swiperViewVehicle" pour afficher le carousel correctement')
        }
    }
    // SmartPhoto - Galerie d'images
    const imgsSmartphoto = document.getElementById('smartphoto');
    if(imgsSmartphoto){
        new smartPhoto(".js-smartPhoto");
    }

    btnsAnchor();

    /* SELECT CUSTOM */
    try {
        const choicesAgency = new Choices('.js-choice__agency', {
            searchEnabled: false,
        });
    } catch (error) {
        console.log('Il manque le block avec la classe ".js-choice__agency" pour afficher le SELECT correctement')
    }

    // Slider AVIS CLIENTS
    if (document.getElementById('swiper-avis-clients')) {
        try {
            /* SWIPER */
            const swiperAvisClients = new Swiper('#swiper-avis-clients', {
                spaceBetween: 20,
                navigation: {
                    nextEl: '.swiper-button-next-avis',
                    prevEl: '.swiper-button-prev-avis',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1.1,
                    },
                    768: {
                        slidesPerView: 1.1,
                    },
                    950: {
                        slidesPerView: 2.1,
                    },
                    1300: {
                        slidesPerView: 3.1
                    },
                }
            });
        } catch (error) {
            console.log('Il manque le block avec l\'id "#swiper-avis-clients" pour afficher le slider correctement')
        }
    }

    // Affichage des btns "Afficher Plus/Moins" pour les "avis clients"
    btnMoreInItem();
    btnMoreInItemResponses();

    // Ajout au favoris depuis la fiche
    const vehiclesFavorite = document.getElementById('view-vehicle_favorite');
    if (vehiclesFavorite) {
        const vehicleId = vehiclesFavorite.dataset.vehicleId;
        vehiclesFavorite.addEventListener('click', e => {
            const addFavoriteEvent = new CustomEvent('addFavoriteView', { detail: {vehicleId : vehicleId, target: e.target } });
            document.dispatchEvent(addFavoriteEvent);
            e.preventDefault();
        });
    }
    document.addEventListener('addFavoriteView', e => {
        favoriteVehicleView(e.detail.vehicleId, e.detail.target);
    });

    const vehiclesComparator = document.getElementById('add-to-compare');
    if (vehiclesFavorite) {
        const vehicleId = vehiclesComparator.dataset.vehicleId;
        vehiclesComparator.addEventListener('click', e => {
            const addFavoriteEvent = new CustomEvent('addComparatorView', { detail: {vehicleId : vehicleId, target: e.target } });
            document.dispatchEvent(addFavoriteEvent);
            e.preventDefault();
        });
    }
    document.addEventListener('addComparatorView', e => {
        comparatorVehicleView(e.detail.vehicleId, e.detail.target);
    });

    // Slider VEHICULES SIMILAIRES
    if (document.getElementById('swiper-vehicle-similaire')) {
        try {
            /* SWIPER */
            const swiperVehicleSimilaire = new Swiper('#swiper-vehicle-similaire', {
                spaceBetween: 20,
                navigation: {
                    nextEl: '.swiper-button-next-similary',
                    prevEl: '.swiper-button-prev-similary',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1.1,
                    },
                    768: {
                        slidesPerView: 2.1,
                    },
                    991: {
                        slidesPerView: 3.1,
                    },
                    1200: {
                        slidesPerView: 4
                    },
                }
            });
        } catch (error) {
            console.log('Il manque le block avec l\'id "#swiper-vehicle-similaire" pour afficher le slider correctement')
        }
    }

    /*************/
    // Stack info prix bloc droite
    const panelPrice = document.querySelector('#panelPrice');
    const headerHeight =  document.querySelector('#header').offsetHeight;
    const anchorsHeight =  document.querySelector('#anchorAncres').offsetHeight;
    const panelPriceHeight =  document.querySelector('#panelPrice').offsetHeight;
    const sommeDesHeight = headerHeight + anchorsHeight +panelPriceHeight;

    if (window.matchMedia('(min-width: 992px)').matches) {
        window.addEventListener('scroll', function() {
            let anchorsMarginTop =  document.querySelector('#anchorAncres').getBoundingClientRect().top;
            let blockAvisMarginTop = document.querySelector('#anchorPanelPrice').getBoundingClientRect().top;
            if ( anchorsMarginTop <= headerHeight && blockAvisMarginTop > sommeDesHeight ) {
                panelPrice.classList.add('position-fixed');

                /*function fadeIn(element, duration = 600) {
                    element.style.display = '';
                    element.style.opacity = 0;
                    let last = +new Date();
                    const tick = function() {
                        element.style.opacity = +element.style.opacity + (new Date() - last) / duration;
                        last = +new Date();
                        if (+element.style.opacity < 1) {
                            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
                        }
                    };
                    tick();
                }
                fadeIn(document.getElementById('panelPrice'), 600);*/

                /*function fadeIn(el, display){
                    el.style.opacity = 0;
                    el.style.display = display || "block";

                    (function fade() {
                        let val = parseFloat(el.style.opacity);
                        if (!((val += .1) > 1)) {
                            el.style.opacity = val;
                            requestAnimationFrame(fade);
                        }
                    })();
                }
                fadeIn( panelPrice, "block" );*/

            }
            else {
                panelPrice.classList.remove('position-fixed');
                //panelPrice.style.opacity = "1";
            }
        });
    }

    const modal = document.getElementById('modal-funding');
    modal.addEventListener('show.bs.modal', (e) => {
        const url = document.getElementById('modal-info-button').dataset.url;
        const options = {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }
        fetch(url, options).then((response) => {
            response.json().then((json) => {
                const modalDetails = document.getElementById('modal-details');
                const modalLegals = document.getElementById('modal-legals');
                modalDetails.innerHTML = json.content[0];
                modalLegals.innerHTML  = json.content[1];
            });
        });
    });


    const modallivraisonSubmit = document.getElementById('modal-livraison-submit');
    if (modallivraisonSubmit) {
        modallivraisonSubmit.addEventListener('click', e => {
            e.preventDefault();
            document.getElementById('modal-livraison-details').classList.remove('d-none');
        })
    }
});
